import request from '../request';

const baseUrl = request.getBaseUrl();

const server = {
  // 公告管理列表
  queryAnnouncementPageInfo(params) {
    return request.post('/cms/purchaseAnnouncement/queryAnnouncementPageInfo', params);
  },
  // 新增
  addAnnouncement(params) {
    return request.post('/cms/purchaseAnnouncement/addAnnouncement', params);
  },
  // 公告预览
  queryAnnouncement(params) {
    return request.fetch('/cms/purchaseAnnouncement/queryAnnouncement', params);
  },
  // 公告修改
  modifyAnnouncement(params) {
    return request.post('/cms/purchaseAnnouncement/modifyAnnouncement', params);
  },
  // 删除公告接口
  removeAnnouncement(params) {
    return request.post('/cms/purchaseAnnouncement/removeAnnouncement', params);
  },
  // 发布状态修改接口
  modifyAnnouncementStatus(params) {
    return request.post('/cms/purchaseAnnouncement/modifyAnnouncementStatus', params);
  },
  // 附件上传接口
  fileUpload: `${baseUrl}/cms/purchaseAnnouncement/fileUpload`,
  // 提交接口
  commitAnnouncement(params) {
    return request.post('/cms/purchaseAnnouncement/commitAnnouncement', params);
  },
  upload(params) {
    return request.post(`${baseUrl}/cms/cms/collegeImageUpload`, params);
  },
  modifyAnnouncementStatusAfterCommit(params) {
    return request.post(`/cms/purchaseAnnouncement/modifyAnnouncementStatusAfterCommit`, params);
  },
  // 公司部门
  queryCurrentGroupWithOrg(params) {
    return request.post(`/user-center/companyHierarchy/queryCurrentGroupWithOrg`, params);
  },
};

export default server;
